import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const useBranchStore = create(
  persist(
    (set) => ({
      selectedCompanyId: null,
      selectedBranchId: null,
      setSelectedCompanyId: (selectedCompanyId) => set({ selectedCompanyId }),
      setSelectedBranchId: (selectedBranchId) => set({ selectedBranchId }),
      clearSelectedBranchId: () => set({ selectedCompanyId: null, selectedBranchId: null })
    }),
    {
      name: 'branchStore',
      storage: createJSONStorage(() => localStorage)
    }
  )
);

export default useBranchStore;
